import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    HiOutlineHome,
    HiOutlineBriefcase,
    HiOutlineSearch,
    HiOutlineChatAlt2,
    HiOutlineCog,
    HiOutlineBell,
    HiOutlineLocationMarker,
    HiX,
    HiCheckCircle,
    HiPlus
} from "react-icons/hi";

// Mock Data
const mockCreator = {
    id: 1,
    name: "Kamran Razvi",
    username: "kamranrazvii",
    bio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    location: "Hyderabad, In.",
    niches: ["Fashion", "Travel", "Beauty"],
    campaignsCompleted: 10,
    portfolio: [
        { id: 1, brand: "Puma", name: "Name", date: "12-09-24", color: "bg-red-50", brandColor: "bg-white", logo: "fa-solid fa-cat" },
        { id: 2, brand: "Puma", name: "Name", date: "12-09-24", color: "bg-gray-800", brandColor: "bg-white", logo: "fa-solid fa-cat" },
        { id: 3, brand: "Nike", name: "Name", date: "12-09-24", color: "bg-slate-700", brandColor: "bg-black", logo: "fa-solid fa-check" },
        { id: 4, brand: "Puma", name: "Name", date: "12-09-24", color: "bg-gray-700", brandColor: "bg-white", logo: "fa-solid fa-cat" },
        { id: 5, brand: "Adidas", name: "Name", date: "12-09-24", color: "bg-gray-600", brandColor: "bg-[#0044CC]", logo: "fa-brands fa-adidas" },
        { id: 6, brand: "Puma", name: "Name", date: "12-09-24", color: "bg-stone-200", brandColor: "bg-white", logo: "fa-solid fa-cat" }
    ],
    activeCampaigns: [
        { id: 101, name: "Adidas", status: "In Review", statusColor: "text-gray-500", deadline: "Deadline in 2 days", deadlineColor: "text-red-500", color: "bg-indigo-50" },
        { id: 102, name: "Loreal", status: "Content Creation", statusColor: "text-gray-500", deadline: "Deadline in 5 days", deadlineColor: "text-red-500", color: "bg-teal-50" },
        { id: 103, name: "H&M", status: "Approved", statusColor: "text-gray-500", deadline: "Pending Payment", deadlineColor: "text-red-500", color: "bg-yellow-50" }
    ]
};

const CreatorProfile = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    
    const [selectedPortfolioItem, setSelectedPortfolioItem] = useState(null);
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
    const [selectedCampaignId, setSelectedCampaignId] = useState(null);

    return (
        <div className="flex h-screen bg-[#FDFBF7]">
            {/* Sidebar */}
            <aside className="w-64 bg-white border-r border-gray-100 flex flex-col hidden md:flex">
                <div className="p-6 flex items-center gap-2 text-black font-bold text-xl">
                    <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                    <span>Braccet</span>
                </div>

                <nav className="flex-1 px-4 py-6 space-y-2">
                    <NavItem to="/brand/dashboard" icon={<HiOutlineHome />} label="Overview" />
                    <NavItem to="/brand/campaigns" icon={<HiOutlineBriefcase />} label="Campaigns" />
                    <NavItem to="/brand/search" icon={<HiOutlineSearch />} label="Find Creators" active />
                    <NavItem to="/brand/messages" icon={<HiOutlineChatAlt2 />} label="Messages" />
                    <NavItem to="/brand/settings" icon={<HiOutlineCog />} label="Settings" />
                </nav>

                <div className="p-4 border-t border-gray-100">
                    <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-gray-50 cursor-pointer">
                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold">
                            B
                        </div>
                        <div>
                            <p className="text-sm font-bold text-gray-900">Brand Name</p>
                            <p className="text-xs text-gray-500">brand@example.com</p>
                        </div>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-1 overflow-hidden flex flex-col h-screen">
                <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 px-6 py-3 flex justify-between items-center shrink-0">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate(-1)}
                            className="text-gray-500 hover:text-gray-900 transition-colors"
                        >
                            <i className="fa-solid fa-arrow-left text-xl"></i>
                        </button>
                        <h1 className="text-2xl font-bold text-gray-900">Creator Profile</h1>
                    </div>
                    <div className="flex items-center gap-4">
                        <button className="p-2 text-gray-400 hover:text-gray-600 relative">
                            <HiOutlineBell className="text-xl" />
                            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
                        </button>
                        <button
                            className="bg-[#0044CC] text-white px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 hover:bg-blue-700 transition-colors"
                            onClick={() => window.location.href = '/brand/create-campaign'}
                        >
                            <HiPlus className="text-lg" />
                            Create Campaign
                        </button>
                    </div>
                </header>

                {/* Content Container */}
                <div className="flex-1 overflow-y-auto p-8">
                    <div className="max-w-6xl mx-auto space-y-8">
                        
                        {/* Profile Header Card */}
                        <div className="bg-[#EEF2FF] rounded-[2rem] p-10 flex flex-col md:flex-row gap-10">
                            {/* Avatar & Location */}
                            <div className="flex flex-col items-center gap-6 shrink-0">
                                <div className="w-48 h-48 rounded-full bg-gray-200 border-4 border-white shadow-sm overflow-hidden flex items-center justify-center">
                                    <img src={`https://i.pravatar.cc/300?u=${mockCreator.id}`} alt={mockCreator.name} className="w-full h-full object-cover" />
                                </div>
                                <div className="flex items-center gap-2 text-sm font-bold text-gray-800">
                                    <HiOutlineLocationMarker className="text-gray-500" />
                                    <span>{mockCreator.location}</span>
                                </div>
                            </div>

                            {/* Info */}
                            <div className="flex-1 flex flex-col isolate relative pt-2">
                                {/* Name and Verified */}
                                <div className="flex items-center gap-2 mb-1">
                                    <h1 className="text-4xl font-bold text-gray-900">{mockCreator.name}</h1>
                                    <div className="group relative">
                                        <HiCheckCircle className="text-blue-500 text-2xl cursor-help mt-1" />
                                        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 bg-white border border-blue-100 text-blue-600 text-xs font-bold rounded-lg shadow-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                                            Braccet verified
                                        </div>
                                    </div>
                                </div>
                                <p className="text-gray-600 text-xl font-medium mb-6">{mockCreator.username}</p>

                                {/* Social Links & Request Button Row */}
                                <div className="flex justify-between items-center mb-8">
                                    <div className="flex gap-3">
                                        <button className="w-8 h-8 rounded-md border border-gray-300 flex items-center justify-center text-gray-600 bg-white hover:bg-gray-50">
                                            <i className="fa-brands fa-instagram"></i>
                                        </button>
                                        <button className="w-8 h-8 rounded-md border border-gray-300 flex items-center justify-center text-gray-600 bg-white hover:bg-gray-50">
                                            <i className="fa-brands fa-youtube"></i>
                                        </button>
                                    </div>
                                    <button 
                                        onClick={() => setIsRequestModalOpen(true)}
                                        className="bg-[#0044CC] text-white px-6 py-2.5 rounded-xl font-bold text-sm hover:bg-blue-700 transition-colors shadow-lg shadow-blue-200"
                                    >
                                        Request Campaign
                                    </button>
                                </div>

                                {/* Bio */}
                                <div className="mb-8 max-w-2xl">
                                    <h3 className="text-sm font-bold text-gray-900 mb-2">Bio</h3>
                                    <p className="text-gray-600 text-sm leading-relaxed">{mockCreator.bio}</p>
                                </div>

                                {/* Stats Row */}
                                <div className="flex justify-between items-end border-t border-blue-100/50 pt-8 mt-auto">
                                    {/* Niches */}
                                    <div>
                                        <h3 className="text-sm font-bold text-gray-900 mb-3">Niches</h3>
                                        <div className="flex gap-2">
                                            {mockCreator.niches.map((niche, i) => {
                                                const colors = ['bg-yellow-50 text-yellow-700', 'bg-green-50 text-green-700', 'bg-orange-50 text-orange-700'];
                                                const icons = ['fa-solid fa-hanger bg-transparent', 'fa-solid fa-plane text-xs', 'fa-solid fa-paintbrush text-xs'];
                                                return (
                                                    <span key={i} className={`px-3 py-1.5 rounded-full text-xs font-bold flex items-center gap-1.5 ${colors[i % colors.length]}`}>
                                                        <i className={`${icons[i % icons.length]} opacity-50`}></i> {niche}
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    </div>

                                    {/* Worked With */}
                                    <div className="flex flex-col items-center">
                                        <h3 className="text-sm font-bold text-gray-900 mb-3">Worked with</h3>
                                        <div className="flex -space-x-2">
                                            <div className="w-8 h-8 rounded-full bg-black border-2 border-white flex items-center justify-center text-white text-[8px] font-bold z-[3]">L'OREAL</div>
                                            <div className="w-8 h-8 rounded-full bg-blue-600 border-2 border-[#EEF2FF] flex items-center justify-center text-white text-[10px] z-[2]"><i className="fa-brands fa-adidas"></i></div>
                                            <div className="w-8 h-8 rounded-full bg-white border-2 border-[#EEF2FF] flex items-center justify-center text-black text-[10px] z-[1]">PUMA</div>
                                        </div>
                                    </div>

                                    {/* Completed count */}
                                    <div className="text-right">
                                        <h3 className="text-sm font-bold text-gray-900 mb-2">Campaign Completed</h3>
                                        <p className="text-3xl font-light text-gray-700">{mockCreator.campaignsCompleted}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Portfolio Grid */}
                        <div>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6">Campaign Completed</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {mockCreator.portfolio.map(item => (
                                    <div 
                                        key={item.id} 
                                        onClick={() => setSelectedPortfolioItem(item)}
                                        className={`rounded-3xl cursor-pointer ${item.color} h-80 relative overflow-hidden group transition-transform hover:-translate-y-1`}
                                    >
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-100 flex flex-col justify-end p-6">
                                            <div className="flex justify-between items-end">
                                                <div className="text-white">
                                                    <h4 className="font-bold text-lg mb-1">{item.name}</h4>
                                                    <p className="text-xs text-gray-300">{item.date}</p>
                                                </div>
                                                <div className={`w-8 h-8 rounded-full ${item.brandColor} flex items-center justify-center`}>
                                                    <i className={`${item.logo} ${item.brandColor === 'bg-white' ? 'text-black' : 'text-white'} text-xs`}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

                {/* Portfolio Item Zoom Modal */}
                {selectedPortfolioItem && (
                    <div className="absolute inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setSelectedPortfolioItem(null)}>
                        <div 
                            className={`w-full max-w-md aspect-[3/4] ${selectedPortfolioItem.color} rounded-3xl relative overflow-hidden shadow-2xl animate-fadeIn`}
                            onClick={e => e.stopPropagation()}
                        >
                            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-8 flex justify-between items-end h-1/2">
                                <div className="text-white">
                                    <h4 className="font-bold text-3xl mb-2">{selectedPortfolioItem.name}</h4>
                                    <p className="text-sm text-gray-300">{selectedPortfolioItem.date}</p>
                                </div>
                                <div className={`w-12 h-12 rounded-full ${selectedPortfolioItem.brandColor} flex items-center justify-center shadow-lg border-2 border-white/20`}>
                                    <i className={`${selectedPortfolioItem.logo} ${selectedPortfolioItem.brandColor === 'bg-white' ? 'text-black' : 'text-white'}`}></i>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Request Campaign Modal */}
                {isRequestModalOpen && (
                    <div className="absolute inset-0 bg-white/80 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
                        <div className="bg-white rounded-[2rem] p-8 max-w-4xl w-full shadow-2xl relative animate-fadeIn border border-gray-100">
                            
                            {/* Close Button */}
                            <button 
                                onClick={() => setIsRequestModalOpen(false)}
                                className="absolute top-6 right-6 text-gray-400 hover:text-gray-900 transition-colors"
                            >
                                <HiX className="text-2xl" />
                            </button>

                            <div className="flex justify-between items-center mb-8 pr-12">
                                <h2 className="text-2xl font-bold text-gray-900">Select a Campaign</h2>
                                <div className="relative w-72">
                                    <input 
                                        type="text" 
                                        className="w-full bg-white border border-gray-200 rounded-full px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <HiOutlineSearch className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" />
                                </div>
                            </div>
                            
                            {/* Campaigns Horizontal List */}
                            <div className="flex gap-6 overflow-x-auto pb-6 pt-2 custom-scrollbar">
                                {mockCreator.activeCampaigns.map(camp => (
                                    <div 
                                        key={camp.id}
                                        onClick={() => setSelectedCampaignId(camp.id)}
                                        className={`min-w-[280px] rounded-3xl p-6 cursor-pointer transition-all flex flex-col items-center justify-center border-2
                                            ${selectedCampaignId === camp.id ? 'border-[#0044CC]' : 'border-transparent shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)]'}
                                        `}
                                    >
                                        <div className={`w-full aspect-square ${camp.color} rounded-2xl mb-6`}></div>
                                        <div className="w-full">
                                            <h4 className="font-bold text-gray-900 text-sm mb-1">{camp.name}</h4>
                                            <p className={`text-[10px] ${camp.statusColor} font-medium mb-3`}>Status : {camp.status}</p>
                                            <div className="inline-block px-3 py-1 bg-red-50 text-red-500 text-[10px] font-bold rounded-lg w-full text-center">
                                                {camp.deadline}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Actions */}
                            <div className="flex justify-end gap-4 mt-6">
                                <button 
                                    onClick={() => setIsRequestModalOpen(false)}
                                    disabled={!selectedCampaignId}
                                    className={`px-10 py-3 font-bold rounded-2xl transition-colors
                                        ${selectedCampaignId 
                                            ? 'bg-[#0044CC] text-white hover:bg-blue-700 shadow-lg shadow-blue-200' 
                                            : 'bg-gray-300 text-white cursor-not-allowed'
                                        }
                                    `}
                                >
                                    Request Campaign
                                </button>
                            </div>
                            
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
};


const NavItem = ({ to, icon, label, active }) => (
    <Link to={to} className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${active ? 'bg-blue-50 text-[#0044CC]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}>
        <span className="text-xl">{icon}</span>
        {label}
    </Link>
);

export default CreatorProfile;
